/**
 * VSCode 환경 감지 유틸리티
 */ // VSCode 환경 감지 함수 (개선된 버전)
export var isVSCodeEnvironment = function() {
    if (typeof window === 'undefined') return false;
    // VSCode API 존재 여부만 확인 (가장 신뢰할 수 있는 방법)
    var hasVsCodeApi = typeof window.acquireVsCodeApi === 'function';
    // URL에 vscode 관련 패턴이 있는지 확인
    var urlContainsVSCode = window.location.href.includes('vscode-webview') || window.location.href.includes('vscode-file');
    // 결과: 두 조건 중 하나만 만족하면 VSCode 환경
    var result = hasVsCodeApi || urlContainsVSCode;
    console.log('[AuthContext] VSCode 환경 감지:', {
        hasVsCodeApi: hasVsCodeApi,
        urlContainsVSCode: urlContainsVSCode,
        result: result,
        url: window.location.href
    });
    return result;
};
